import React from "react";

import styles from "../../../../../styles/add-product.module.scss";

import { Hairline } from "../../../../components/Hairline";
import { Input } from "../../../../components/Input";
import { Label } from "../../../../components/Label";
import { Checkbox } from "../../../../components/Checkbox";

export default class SetPizzaSizesStepChild extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: props.category,
      product: props.product,
      onChange: props.onChange || {},
      onChangePromo: props.onChangePromo || {},
    };
  }

  fixChecked = (value, index) => {
    const sizes = this.state.product.sizes;
    sizes[index].promo = value
    this.setState({ product: { ...this.state.product, sizes } });
    this.state.onChangePromo(sizes, index);
  };

  render() {
    return (
      <>
        {
          this.state.category.sizes.map((size, index) => {
            return (
              <div key={index}>
                <Label>Qual é o valor por tamanho?</Label>
                <div className="d-flex mb-20">
                  <div className={styles.sizeName}>{size.name}</div>
                  <Input
                    design="four"
                    id={`size.${index}`}
                    onChange={(e) => { this.state.onChange(e.target.value, index) }}
                    placeholder="R$ 0,00"
                    className="w-50"
                  />
                </div>
                <Checkbox
                  id={`promotion.${index}`}
                  checked={this.state.product.sizes[index].promo}
                  onChange={(e) => { this.fixChecked(e, index) }}
                >
                  Este sabor está em promoção neste tamanho
                </Checkbox>
                {
                  (index < this.state.category.sizes.length - 1) &&
                  <Hairline className="mt-20 mb-20" />
                }
              </div>
            )
          })
        }
      </>
    );
  }
}
